/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unnecessary-type-assertion */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/**
 * 奖励金 接口 yapi https://yapi.hellobike.cn/project/6149/interface/api/cat_43946
 * */
import store from '@/store';
import request from '@hb/sharp-request';
import platform from '@/shared/utils/platform';

import { newGatewayUrl } from '@/constant';
import {
  AcceptTaskListParamsType,
  GetRewardingTaskListParams,
  ReceiveAwardParamsType,
  rewardingSceneNameEn,
  rewardingSubSceneNameEn,
  RewardingTasksInfo,
  TaskType,
  CashActivityDetailResType,
} from './types';

const getBaseStore = () => store.state.base;
const { cityInfo } = getBaseStore();
const adCode = (cityInfo as NativeModel.CityInfo).adCode
  || (cityInfo as NativeModel.AliCityInfo).cityAdcode
  || '';
const cityCode = (cityInfo as NativeModel.CityInfo).cityCode || '';

// 查询奖励金任务列表
export const getRewardingTaskList = (
  params: GetRewardingTaskListParams,
): Promise<RewardingTasksInfo> => {
  const { appVersion = '' } = getBaseStore().deviceInfo;

  return request.postGate(
    'f.activity.hello.task.show',
    {
      ...params,
      // 是否查询已结束未领奖的任务
      queryUnrewardedTasks: true,
      // 渠道id
      channelId: platform.code,
      // 场景英文名
      sceneNameEn: rewardingSceneNameEn,
      // 子场景英文名
      subSceneNameEn: rewardingSubSceneNameEn,
      // 客户端编号
      systemCode: platform.systemCode,
      adCode,
      cityCode,
      version: appVersion,
    },
    {
      baseURL: newGatewayUrl,
      showLoading: undefined,
      showErrMsg: undefined,
    },
  );
};

// 批量领取奖励金任务
export const acceptRewardingTaskList = (
  params: AcceptTaskListParamsType,
): Promise<TaskType[]> => request.postGate(
  'f.activity.hello.task.accept.list',
  {
    ...params,
    // 渠道id
    channelId: platform.code,
    // 场景英文名
    sceneNameEn: rewardingSceneNameEn,
    // 子场景英文名
    subSceneNameEn: rewardingSubSceneNameEn,
    // 客户端编号
    systemCode: platform.systemCode,
    adCode,
    cityCode,
  },
  {
    baseURL: newGatewayUrl,
    showLoading: undefined,
  },
);

// 手动领取奖励金奖励
export const receiveAward = (
  params: ReceiveAwardParamsType,
): Promise<string> => request.postGate(
  'f.activity.hello.task.receive.award',
  {
    ...params,
    // 渠道id
    channelId: platform.code,
    // 客户端编号
    systemCode: platform.systemCode,
    adCode,
    cityCode,
  },
  {
    baseURL: newGatewayUrl,
    showLoading: undefined,
  },
);

// 触发现金活动奖励
export const triggerCashActivity = (): Promise<void> => request.postGate(
  'f.activity.trigger.cash.activity',
  {},
  {
    baseURL: newGatewayUrl,
    showLoading: undefined,
  },
);

// 获取现金活动详情
export const getCashActivityDetail = (): Promise<CashActivityDetailResType> => request.postGate(
  'f.activity.cash.activity.bdi.filter',
  {},
  {
    baseURL: newGatewayUrl,
    showLoading: undefined,
  },
);
